import http from '@/utils/http';
const base_path = '/v2/media';

/**
 * 批量修改广告主返点
 * @param {Object} data 查询参数
 * @returns {Promise<Object>}
 */
export const batchUpdateRebateApi = (data) => {
  return http.put({
    url: `${base_path}/batchUpdateRebate`,
    data,
  });
};
